import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { EditOutlined } from '@ant-design/icons';

import colors from '../../constants/Colors';

const ICON_STYLE = {
  color: '#FFF',
  cursor: 'help',
};

export default function EditedClockInIcon({
  style = {},
  size = 14,
  marginLeft = 4,
}) {
  return (
    <Popover content="Clock in time was edited by an admin">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '50%',
          backgroundColor: colors.ONTRACCR_RED,
          padding: 4,
          width: size + 8,
          height: size + 8,
          justifyContent: 'center',
          marginLeft,
        }}
      >
        <EditOutlined
          style={{
            ...ICON_STYLE,
            fontSize: size,
            ...style,
          }}
        />
      </div>
    </Popover>
  );
}

EditedClockInIcon.propTypes = {
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  size: PropTypes.number,
  marginLeft: PropTypes.number,
};

EditedClockInIcon.defaultProps = {
  style: {},
  size: 14,
  marginLeft: 4,
};
